/**
 * Adds CDN support to the SystemJS loader by overriding the System.fetch
 * hook. By design, all the modules must be downloaded from our CDN, i.e.
 * external URLs (although supported by SystemJS) are not allowed for
 * performance reasons.
 */
(function() {
  'use strict';

  // CDN hostnames are read from the `flns` global var.
  // Let's make them actual URLs first.
  // TODO: remove these since they are now deprecated, see T22769.
  var CDN_URLS = window.__SystemCdnUrls.map(function(url) {
    return 'https://' + url;
  });

  var S3_URL = window.__S3CdnUrl;

  // Override the System.fetch hook to download all the modules from the CDN
  var systemFetch = window.System.fetch;
  window.System.fetch = function(load) {
    // Polyfill window.location.origin for IE.
    var origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    var path = load.address.split(origin + '/')[1];

    load.address = S3_URL + '/' + path.replace(/^assets\//, '');
    return systemFetch.call(this, load);
  };

})();
